import * as actionTypes from '../../../actions/actionTypes';
const defaultObject={
    inspectionReport:[]
}
export const driverInspectionReducer = (state = defaultObject, action) => {
    switch (action.type) {
      case actionTypes.GET_INSPECTION_REPORT:
        return {...state ,inspectionReport:(action.inspectionReport||defaultObject.inspectionReport)};  
      default:
        return state;
    }
  };